import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { Fragment as h } from "react";
import { c as i } from "../../createLucideIcon-BC8wu-bu.js";
import '../../assets/Table.css';/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n = i("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
function b({ headers: t, rows: l, className: r = "" }) {
  return /* @__PURE__ */ c("div", { className: `table-container ${r}`, children: [
    /* @__PURE__ */ c("table", { className: "table", children: [
      /* @__PURE__ */ e("thead", { className: "table-thead", children: /* @__PURE__ */ e("tr", { className: "table-theadTr", children: t.map((a) => /* @__PURE__ */ e("th", { className: "table-theadTh", children: a }, a)) }) }),
      /* @__PURE__ */ e("tbody", { children: l.map((a, d) => /* @__PURE__ */ e(h, { children: a }, d)) })
    ] }),
    !l.length && /* @__PURE__ */ c("div", { className: "table-placeholder", children: [
      /* @__PURE__ */ e(n, {}),
      /* @__PURE__ */ e("p", { className: "table-placeholderText", children: "No data." })
    ] })
  ] });
}
export {
  b as Table
};
//# sourceMappingURL=Table.js.map
